import React from 'react';

// Assets
import { ReactComponent as AnalyticsPortfolio } from '@/images/analytics-portfolio.svg?react';
import { ReactComponent as AnalyticsClient } from '@/images/analytics-client.svg?react';
import { ReactComponent as AnalyticsModel } from '@/images/analytics-model.svg?react';
import { ReactComponent as AnalysisFactSetPortfolios } from '@/images/analysis-factset-portfolios.svg?react';

// Components
import ActionCardButton from '../buttons/ActionCardButton';

// Utils
import { formatMessage } from '@/utils/i18n/i18n';

type Props = {
  className?: string;
  hasClientAccountPermission: boolean;
  hasModelPortfolioPermission: boolean;
  hasNewPortfolioPermission: boolean;
  hasLoadFactSetPortfolios?: boolean;
  onClickClient?: () => void;
  onClickModel?: () => void;
  onClickPortfolio?: () => void;
  onClickLoadFactSetPortfolios?: () => void;
};

const ComparisonActionCards = ({
  className = '',
  hasClientAccountPermission,
  hasModelPortfolioPermission,
  hasNewPortfolioPermission,
  hasLoadFactSetPortfolios,
  onClickClient,
  onClickModel,
  onClickPortfolio,
  onClickLoadFactSetPortfolios,
}: Props) => (
  <div className={`cards ${className}`}>
    {hasNewPortfolioPermission && onClickPortfolio && (
      <ActionCardButton
        title={formatMessage('ComparisonHome.CreateAnalysisModal.Card1.Title')}
        description={formatMessage('ComparisonHome.CreateAnalysisModal.Card1.Description')}
        onClick={onClickPortfolio}
      >
        <AnalyticsPortfolio className="card-img-top" />
      </ActionCardButton>
    )}

    {hasClientAccountPermission && onClickClient && (
      <ActionCardButton
        title={formatMessage('ComparisonHome.CreateAnalysisModal.Card2.Title')}
        description={formatMessage('ComparisonHome.CreateAnalysisModal.Card2.Description')}
        onClick={onClickClient}
      >
        <AnalyticsClient className="card-img-top" />
      </ActionCardButton>
    )}

    {hasModelPortfolioPermission && onClickModel && (
      <ActionCardButton
        title={formatMessage('ComparisonHome.CreateAnalysisModal.Card3.Title')}
        description={formatMessage('ComparisonHome.CreateAnalysisModal.Card3.Description')}
        onClick={onClickModel}
      >
        <AnalyticsModel className="card-img-top" />
      </ActionCardButton>
    )}

    {hasLoadFactSetPortfolios && onClickLoadFactSetPortfolios && (
      <ActionCardButton
        title={formatMessage('ComparisonHome.CreateAnalysisModal.Card4.Title')}
        description={formatMessage('ComparisonHome.CreateAnalysisModal.Card4.Description')}
        onClick={onClickLoadFactSetPortfolios}
      >
        <AnalysisFactSetPortfolios className="card-img-top" />
      </ActionCardButton>
    )}
  </div>
);

export default ComparisonActionCards;
